import { QuestionCircleOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { Tooltip } from 'antd';
import { useTranslate } from '@tolgee/react';

const Icon = styled(QuestionCircleOutlined)`
  margin: 0 4px;
  cursor: help;
`;

function TriggerPointTips() {
  const { t } = useTranslate();

  return (
    <Tooltip
      overlayStyle={{
        maxWidth: '400px',
      }}
      title={
        <>
          <div>{t('marketing.根据买家的订单状态选择催好评任务的执行节点。')}</div>
          <div>
            {t(
              'marketing.切换执行节点时，需注意任务组中发送的内容是否符合当前选择执行节点的订单状态。',
            )}
          </div>
        </>
      }
    >
      <Icon />
    </Tooltip>
  );
}

export default TriggerPointTips;
